import * as propertyTypes from "../property_types.js"


export class UiKendoMultiselect extends propertyTypes.AppBaseComponentProps {

    private listWidthMetadata = new propertyTypes.CheckBoxProperty("listWidth", "List width");
    public listWidth: string;

    private primitiveValueMetadata = new propertyTypes.CheckBoxProperty("primitiveValue", "Pritive value");
    public primitiveValue: string;

    private displayTemplateMetadata = new propertyTypes.CheckBoxProperty("displayTemplate", "Display template");
    public displayTemplate: string;

    private templateMetadata = new propertyTypes.CheckBoxProperty("template", "Template");
    public template: string;

    private maxSelectedItemsMetadata = new propertyTypes.CheckBoxProperty("maxSelectedItems", "Max selected items");
    public maxSelectedItems: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.listWidthMetadata, this.primitiveValueMetadata, this.displayTemplateMetadata, this.templateMetadata, this.maxSelectedItemsMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}